import { useTheme } from '@mui/material/styles'
import { colors } from 'Themes/Colors'
import { colors as birdsong } from '@resiliatech/birdsong'

export const useStyles = () => {
  const theme = useTheme()

  return {
    pageWrapper: {
      maxWidth: '1280px',
      margin: '16px auto 12px auto',
      padding: '0 36px',
      display: 'flex',
      flexDirection: 'column',
      background: birdsong.background.primaryBackground,
      [theme.breakpoints.down('sm')]: {
        padding: 0,
      },
    },
    tableWrapper: {
      [theme.breakpoints.down('sm')]: {
        padding: '0',
        margin: '0 -20px',
      },
    },
    pageTitle: {
      marginBottom: '20px',
      display: 'flex',
      alignItems: 'baseline',
    },
    info: {
      fontSize: 18,
      marginRight: 10,
      marginLeft: 15,
      color: colors.resiliaGreen,
    },
    button: {
      marginLeft: 'auto',
    },
    limitSection: {
      display: 'flex',
      width: '100%',
      fontSize: '12.8px',
      fontWeight: 700,
      color: colors.darkGrey,
      justifyContent: 'space-between',
    },
    alert: {
      color: colors.resiliaWhite,
      marginBottom: '45px',
      fontSize: '16px',
      fontWeight: 400,
    },
    alertError: {
      backgroundColor: colors.greyBlue,
    },
    retryButton: {
      color: colors.lightBlue,
      fontSize: '16px',
      fontWeight: 600,
    },
  }
}
